module.exports = __webpack_public_path__ + "img/Dana_logo.53df2a58.png";